import { useEffect, useRef, useState } from 'react';

const useElementOnScreen = (options) => {
  const itemRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const animateCallback = (entries) => {
    const [entry] = entries;
    if (entry.isIntersecting) {
      setIsVisible(entry.isIntersecting);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(animateCallback, options);
    if (itemRef.current) {
      observer.observe(itemRef.current);
    }

    return () => {
      if (itemRef.current) {
        observer.unobserve(itemRef.current);
      }
    };
  }, [itemRef, options]);
  return [itemRef, isVisible];
};

export default useElementOnScreen;
